import { apiRoute, API_V1 } from '@/helpers/api-route'
import { fetchWrapper } from '@/helpers/fetch-wrapper'

const API_BASE = apiRoute() + API_V1 + '/admin/training'

/**
 * Reject (remove) one or more images from a project
 * @param {string} projectId - Project ID
 * @param {Array<string>} imageIds - Array of image IDs to reject
 * @param {string} reason - Rejection reason
 * @param {number} phase - Phase identifier (default: 3 for annotation phase)
 * @returns {Promise<Object>} Response from backend
 */
export function reject(projectId, imageIds, reason, phase = 3) {
  return fetchWrapper.delete(API_BASE + '/remove-images/', {
    projectId: projectId,
    imageIds: imageIds,
    reason: reason,
    phase: phase
  })
}

/**
 * Unreject (restore) one or more images to a project
 * @param {string} projectId - Project ID
 * @param {Array<string>} imageIds - Array of image IDs to restore
 * @param {string} reason - Reason for restoration
 * @returns {Promise<Object>} Response from backend
 */
export function unreject(projectId, imageIds, reason) {
  return fetchWrapper.post(API_BASE + '/restore-images/', {
    projectId: projectId,
    imageIds: imageIds,
    reason: reason
  })
}

export const rejectService = {
  reject,
  unreject
}
